class StoreUtils {
  static partialize = <T extends Record<string, unknown>>(state: T, fields: Array<keyof T>) => {
    return Object.fromEntries(Object.entries(state).filter(([key]) => !fields.includes(key)))
  }
}

export default StoreUtils
